module.exports = __webpack_public_path__ + "img/monitorbox26.8b3d4245.jpg";